import $ from 'jquery';

export default class TemplateAccountAddresses {
  constructor(template) {
    this.el = template.el;
    this.countryProvinceSelectors = [];

    this.countryProvinceSelector = new Shopify.CountryProvinceSelector(
      'address-country',
      'address-province',
      {
        hideElement: 'address-province-container',
      },
    );

    const $addresses = $('[id^=address-country-]', this.el);

    console.log($addresses);

    $addresses.each((index, address) => {
      const $address = $(address);
      const addressId = $address.attr('id').split('-')[2];

      this.countryProvinceSelectors.push(new Shopify.CountryProvinceSelector(
        `address-country-${addressId}`,
        `address-province-${addressId}`,
        {
          hideElement: `address-province-container-${addressId}`,
        },
      ));
    });
  }
}
